import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close mobile menu on page change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Add scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <a href="#main" className="skip-link">Skip to main content</a>
      <div className="container header-container">
        <div className="brand-container">
          <Link to="/" className="logo">
            <img 
              src="/images/logo.svg" 
              alt="The Caffeinated Crumb" 
              width="70" 
              height="70" 
              className="logo-image"
            />
            <div className="brand-text">
              <span className="company-name">The Caffeinated Crumb</span>
              <span className="company-tagline">Homemade Bakery</span>
            </div>
          </Link>
        </div>

        <div className="nav-container">
          <div className="header-actions">
            <button 
              className={`mobile-menu-toggle ${menuOpen ? 'open' : ''}`}
              onClick={toggleMenu}
              aria-expanded={menuOpen}
              aria-controls="main-menu"
              aria-label="Toggle menu"
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
          </div>
        </div>

        <nav className={`main-nav ${menuOpen ? 'active' : ''}`} id="main-menu">
          <ul className="nav-list">
            <li className={location.pathname === '/' ? 'active' : ''}>
              <Link to="/">Home</Link>
            </li>
            <li className={location.pathname.includes('/products') ? 'active' : ''}>
              <Link to="/products">Products</Link>
            </li>
            <li className={location.pathname === '/catering' ? 'active' : ''}>
              <Link to="/catering">Catering</Link>
            </li>
            <li className={location.pathname === '/contact' ? 'active' : ''}>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
